import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
// Side-effect import only: constructing the singleton is what starts the
// connection. Keeps the socket in the eager bundle even if routes go lazy.
import '../services/stsuiWebsocket';
const StsuiWebSocketContext = createContext(undefined);
export const useStsuiWebSocket = () => {
    const context = useContext(StsuiWebSocketContext);
    if (context === undefined) {
        throw new Error('useStsuiWebSocket must be used within a StsuiWebSocketProvider');
    }
    return context;
};
// No connect() here on purpose: the stsuiWebSocketService singleton connects
// itself at import time (its constructor runs activity detection, which checks
// connection state), reconnects on activity/visibility changes, and connects
// lazily from subscribe(). Calling connect() from an effect here only raced with
// the import-time attempt and logged "connection already in progress".
export const StsuiWebSocketProvider = ({ children }) => {
    return _jsx(StsuiWebSocketContext.Provider, { value: {}, children: children });
};
